import React, { useState, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import s from './IconDropdown.css';
import withStyles from 'isomorphic-style-loader/withStyles';
import { api, shopCategoryIconUploadDir } from '../../../../config';
import cx from 'classnames';

const IconDropdown = ({ input, options, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    const selectedOption = options.find(o => String(o.id) === String(input.value));

    const handleSelect = (optionValue) => {
        input.onChange(optionValue);
        setIsOpen(false);
    };

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, wrapperRef]);

    return (
        <div className={s.dropdown} ref={wrapperRef}>
            <div className={s.dropdownHeader} onClick={() => setIsOpen(!isOpen)}>
                {selectedOption ? (
                    <div className={s.selectedOption}>
                        <img src={`${api.apiEndpoint}/${shopCategoryIconUploadDir}/${selectedOption.icon}`} alt={selectedOption.name} className={s.optionIcon} />
                        <span>{selectedOption.name}</span>
                    </div>
                ) : (
                    <span className={s.placeholder}>{placeholder}</span>
                )}
                <span className={cx(s.arrow, { [s.open]: isOpen })}></span>
            </div>
            {isOpen && (
                <div className={s.dropdownList}>
                    {options.map(option => (
                        <div key={option.id} className={s.dropdownListItem} onClick={() => handleSelect(option.id)}>
                            <img src={`${api.apiEndpoint}/${shopCategoryIconUploadDir}/${option.icon}`} alt={option.name} className={s.optionIcon} />
                            <span>{option.name}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default withStyles(s)(IconDropdown); 